module.exports = __webpack_public_path__ + "static/media/NSWLogo.f223e36f.png";